/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Saved_SuccessInputs */

const en_team_manager_group_saved_success = /** @type {(inputs: Team_Manager_Group_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group saved successfully`)
};

const fr_team_manager_group_saved_success = /** @type {(inputs: Team_Manager_Group_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe enregistré avec succès`)
};

const de_team_manager_group_saved_success = /** @type {(inputs: Team_Manager_Group_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe erfolgreich gespeichert`)
};

const it_team_manager_group_saved_success = /** @type {(inputs: Team_Manager_Group_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo salvato con successo`)
};

const ru_team_manager_group_saved_success = /** @type {(inputs: Team_Manager_Group_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа успешно сохранена`)
};

const es_team_manager_group_saved_success = /** @type {(inputs: Team_Manager_Group_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo guardado exitosamente`)
};

const zh_cn2_team_manager_group_saved_success = /** @type {(inputs: Team_Manager_Group_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`群组已成功保存`)
};

const ja_team_manager_group_saved_success = /** @type {(inputs: Team_Manager_Group_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループが正常に保存されました`)
};

const hi_team_manager_group_saved_success = /** @type {(inputs: Team_Manager_Group_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह सफलतापूर्वक बच गया`)
};

const pt_pt2_team_manager_group_saved_success = /** @type {(inputs: Team_Manager_Group_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo salvo com sucesso`)
};

/**
* | output |
* | --- |
* | "Group saved successfully" |
*
* @param {Team_Manager_Group_Saved_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_saved_success = /** @type {((inputs?: Team_Manager_Group_Saved_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Saved_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_group_saved_success(inputs)
	if (locale === "de") return de_team_manager_group_saved_success(inputs)
	if (locale === "it") return it_team_manager_group_saved_success(inputs)
	if (locale === "ru") return ru_team_manager_group_saved_success(inputs)
	if (locale === "es") return es_team_manager_group_saved_success(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_group_saved_success(inputs)
	if (locale === "ja") return ja_team_manager_group_saved_success(inputs)
	if (locale === "hi") return hi_team_manager_group_saved_success(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_group_saved_success(inputs)
	return en_team_manager_group_saved_success(inputs)
});